// Connectivity signal that combines OS-level online/offline events with
// observed network behaviour. navigator.onLine alone lies on iOS Safari and
// in some Chromium setups (e.g. captive portals, VPN drops), so we layer an
// `observed` flag on top that authedFetch updates from real fetch outcomes.
const listeners = new Set();
let osOnline = typeof navigator === "undefined" ? true : navigator.onLine;
let observed = true;
function notify() {
    for (const l of listeners)
        l();
}
if (typeof window !== "undefined") {
    window.addEventListener("online", () => {
        osOnline = true;
        observed = true;
        notify();
    });
    window.addEventListener("offline", () => {
        osOnline = false;
        notify();
    });
}
export function isOnline() {
    return osOnline && observed;
}
export function reportNetworkSuccess() {
    if (!observed) {
        observed = true;
        notify();
    }
}
export function reportNetworkFailure() {
    if (observed) {
        observed = false;
        notify();
    }
}
export function subscribe(listener) {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
}
export function isNetworkError(err) {
    if (err instanceof TypeError)
        return true; // fetch throws TypeError on network failure
    if (err && typeof err === "object" && "name" in err) {
        const name = err.name ?? "";
        if (name === "OfflineError" || name === "TimeoutError")
            return true;
        if (/network|offline/i.test(name))
            return true;
    }
    if (err && typeof err === "object" && "message" in err) {
        const msg = err.message ?? "";
        if (/network|offline|failed to fetch|timed? ?out/i.test(msg))
            return true;
    }
    return false;
}
